export default __webpack_public_path__ + "static/media/Shruti_Sharma_Community_Lead.b2f7553c.jpeg";